/// <amd-module name="Artifacts/Maven/commands/PermanentDelete" />
import { MavenActions } from "Artifacts/Maven/redux";
import { getPermanentDeleteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createPermanentDeleteCommand = getPermanentDeleteCommandCreator(
  MavenActions.permanentDelete,
);
